import Store from 'lightningjs-redux';
import { getPlayerLongSeekFeature, getStoryboardFeature } from '../../../../logic/features/features.selectors';
import { getLiveEdgeInSeconds } from '../../../../logic/player/live.selectors';
import {
  getIsLive,
  getDurationInSeconds,
  getElapsedTimeInSeconds,
  getAdMarkers,
} from '../../../../logic/player/player.selectors';

const mapControllers = instance => [
  {
    selector: getIsLive,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.isLive = value;
    },
  },
  {
    selector: getDurationInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.duration = value;
    },
  },
  {
    selector: getElapsedTimeInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.elapsed = value;
    },
  },
  {
    selector: getLiveEdgeInSeconds,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.playHead = value;
    },
  },
  {
    selector: getStoryboardFeature,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.storyboard = value;
    },
  },
  {
    selector: getPlayerLongSeekFeature,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.longSeekEnabled = value;
    },
  },
  {
    selector: getAdMarkers,
    shouldBeInvokedOnConnect: true,
    callback: value => {
      instance.adMarkers = value;
    },
  },
];

export default Store.control(mapControllers);
